import type { Color } from '@/types/Color'
import type { StatusType } from '@/types/Status'

export const COLOR_CLASSNAMES: Record<Color, string> = {
  red: 'bg-red-600 dark:bg-red-700 border border-red-700 dark:border-red-600 text-white dark:text-white',
  'red-light':
    'bg-red-200 dark:bg-red-800/80 border border-red-300 dark:border-red-800 text-red-900 dark:text-white',
  orange:
    'bg-orange-600 dark:bg-orange-600 border border-orange-700 dark:border-orange-600 text-white dark:text-white',
  'orange-light':
    'bg-orange-200 dark:bg-orange-800/80 border border-orange-300 dark:border-orange-800 text-orange-900 dark:text-white',
  amber:
    'bg-amber-600 dark:bg-amber-600 border border-amber-700 dark:border-amber-600 text-white dark:text-white',
  'amber-light':
    'bg-amber-200 dark:bg-amber-800/80 border border-amber-300 dark:border-amber-800 text-amber-900 dark:text-white',
  yellow:
    'bg-yellow-400 dark:bg-yellow-500 border border-yellow-500 dark:border-yellow-600 text-yellow-900 dark:text-white',
  'yellow-light':
    'bg-yellow-200/80 dark:bg-yellow-800/80 border border-yellow-300 dark:border-yellow-800 text-yellow-900 dark:text-white',
  lime: 'bg-lime-600 dark:bg-lime-600 border border-lime-700 dark:border-lime-600 text-white dark:text-white',
  'lime-light':
    'bg-lime-200 dark:bg-lime-800/80 border border-lime-300 dark:border-lime-800 text-lime-900 dark:text-white',
  green:
    'bg-green-600 dark:bg-green-600 border border-green-700 dark:border-green-600 text-white dark:text-white',
  'green-light':
    'bg-green-300 dark:bg-green-700/80 border border-green-400 dark:border-green-800 text-green-900 dark:text-white',
  emerald:
    'bg-emerald-600 dark:bg-emerald-600 border border-emerald-700 dark:border-emerald-600 text-white dark:text-white',
  'emerald-light':
    'bg-emerald-200 dark:bg-emerald-800/80 border border-emerald-300 dark:border-emerald-800 text-emerald-900 dark:text-white',
  teal: 'bg-teal-600 dark:bg-teal-600 border border-teal-700 dark:border-teal-600 text-white dark:text-white',
  'teal-light':
    'bg-teal-200 dark:bg-teal-800/80 border border-teal-300 dark:border-teal-800 text-teal-900 dark:text-white',
  cyan: 'bg-cyan-600 dark:bg-cyan-600 border border-cyan-700 dark:border-cyan-600 text-white dark:text-white',
  'cyan-light':
    'bg-cyan-200 dark:bg-cyan-800/80 border border-cyan-300 dark:border-cyan-800 text-cyan-900 dark:text-white',
  sky: 'bg-sky-600 dark:bg-sky-600 border border-sky-700 dark:border-sky-600 text-white dark:text-white',
  'sky-light':
    'bg-sky-200 dark:bg-sky-800/80 border border-sky-300 dark:border-sky-800 text-sky-900 dark:text-white',
  blue: 'bg-blue-600 dark:bg-blue-600 border border-blue-700 dark:border-blue-600 text-white dark:text-white',
  'blue-light':
    'bg-blue-200 dark:bg-blue-800/80 border border-blue-300 dark:border-blue-800 text-blue-900 dark:text-white',
  indigo:
    'bg-indigo-600 dark:bg-indigo-600 border border-indigo-700 dark:border-indigo-600 text-white dark:text-white',
  'indigo-light':
    'bg-indigo-200 dark:bg-indigo-800/80 border border-indigo-300 dark:border-indigo-800 text-indigo-900 dark:text-white',
  violet:
    'bg-violet-600 dark:bg-violet-600 border border-violet-700 dark:border-violet-600 text-white dark:text-white',
  'violet-light':
    'bg-violet-200 dark:bg-violet-800/80 border border-violet-300 dark:border-violet-800 text-violet-900 dark:text-white',
  purple:
    'bg-purple-600 dark:bg-purple-600 border border-purple-700 dark:border-purple-600 text-white dark:text-white',
  'purple-light':
    'bg-purple-200 dark:bg-purple-800/80 border border-purple-300 dark:border-purple-800 text-purple-900 dark:text-white',
  fuchsia:
    'bg-fuchsia-600 dark:bg-fuchsia-600 border border-fuchsia-700 dark:border-fuchsia-600 text-white dark:text-white',
  'fuchsia-light':
    'bg-fuchsia-200 dark:bg-fuchsia-800/80 border border-fuchsia-300 dark:border-fuchsia-800 text-fuchsia-900 dark:text-white',
  pink: 'bg-pink-600 dark:bg-pink-600 border border-pink-700 dark:border-pink-600 text-white dark:text-white',
  'pink-light':
    'bg-pink-200 dark:bg-pink-800/80 border border-pink-300 dark:border-pink-800 text-pink-900 dark:text-white',
  rose: 'bg-rose-600 dark:bg-rose-600 border border-rose-700 dark:border-rose-600 text-white dark:text-white',
  'rose-light':
    'bg-rose-200 dark:bg-rose-800/80 border border-rose-300 dark:border-rose-800 text-rose-900 dark:text-white',
  slate:
    'bg-slate-600 dark:bg-slate-600 border border-slate-700 dark:border-slate-600 text-white dark:text-white',
  'slate-light':
    'bg-slate-200 dark:bg-slate-800/80 border border-slate-300 dark:border-slate-800 text-slate-900 dark:text-white',
  gray: 'bg-gray-600 dark:bg-gray-600 border border-gray-700 dark:border-gray-600 text-white dark:text-white',
  'gray-light':
    'bg-gray-200 dark:bg-gray-800/80 border border-gray-300 dark:border-gray-800 text-gray-900 dark:text-white',
  zinc: 'bg-zinc-600 dark:bg-zinc-600 border border-zinc-700 dark:border-zinc-600 text-white dark:text-white',
  'zinc-light':
    'bg-zinc-200 dark:bg-zinc-800/80 border border-zinc-300 dark:border-zinc-800 text-zinc-900 dark:text-white',
  neutral:
    'bg-neutral-600 dark:bg-neutral-600 border border-neutral-700 dark:border-neutral-600 text-white dark:text-white',
  'neutral-light':
    'bg-neutral-200 dark:bg-neutral-800/80 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-white',
  stone:
    'bg-stone-600 dark:bg-stone-600 border border-stone-700 dark:border-stone-600 text-white dark:text-white',
  'stone-light':
    'bg-stone-200 dark:bg-stone-800/80 border border-stone-300 dark:border-stone-800 text-stone-900 dark:text-white',
  black:
    'bg-black border border-black dark:border-black text-white dark:text-white',
  white:
    'bg-white border border-primary-200 dark:border-primary-800 text-primary-900 dark:text-white',
}

export const COLOR_CLASSNAMES_WITH_HOVER: Record<Color, string> = {
  red: 'bg-red-600 hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-600 border border-red-700 dark:border-red-600 text-white dark:text-white',
  'red-light':
    'bg-red-200 hover:bg-red-300 dark:bg-red-800/80 dark:hover:bg-red-700/80 border border-red-300 dark:border-red-800 text-red-900 dark:text-white',
  orange:
    'bg-orange-600 hover:bg-orange-700 dark:bg-orange-600 dark:hover:bg-orange-500 border border-orange-700 dark:border-orange-600 text-white dark:text-white',
  'orange-light':
    'bg-orange-200 hover:bg-orange-300 dark:bg-orange-800/80 dark:hover:bg-orange-700/80 border border-orange-300 dark:border-orange-800 text-orange-900 dark:text-white',
  amber:
    'bg-amber-600 hover:bg-amber-700 dark:bg-amber-600 dark:hover:bg-amber-500 border border-amber-700 dark:border-amber-600 text-white dark:text-white',
  'amber-light':
    'bg-amber-200 hover:bg-amber-300 dark:bg-amber-800/80 dark:hover:bg-amber-700/80 border border-amber-300 dark:border-amber-800 text-amber-900 dark:text-white',
  yellow:
    'bg-yellow-400 hover:bg-yellow-500 dark:bg-yellow-500 dark:hover:bg-yellow-400 border border-yellow-500 dark:border-yellow-600 text-yellow-900 dark:text-white',
  'yellow-light':
    'bg-yellow-200/80 hover:bg-yellow-300/80 dark:bg-orange-900 dark:hover:bg-orange-800 border border-yellow-300 dark:border-orange-800 text-yellow-900 dark:text-white',
  lime: 'bg-lime-600 hover:bg-lime-700 dark:bg-lime-600 dark:hover:bg-lime-500 border border-lime-700 dark:border-lime-600 text-white dark:text-white',
  'lime-light':
    'bg-lime-200 hover:bg-lime-300 dark:bg-lime-800/80 dark:hover:bg-lime-700/80 border border-lime-300 dark:border-lime-800 text-lime-900 dark:text-white',
  green:
    'bg-green-600 hover:bg-green-700 dark:bg-green-600 dark:hover:bg-green-500 border border-green-700 dark:border-green-600 text-white dark:text-white',
  'green-light':
    'bg-green-300 hover:bg-green-400 dark:bg-green-700/80 dark:hover:bg-green-600/80 border border-green-400 dark:border-green-800 text-green-900 dark:text-white',
  emerald:
    'bg-emerald-600 hover:bg-emerald-700 dark:bg-emerald-600 dark:hover:bg-emerald-500 border border-emerald-700 dark:border-emerald-600 text-white dark:text-white',
  'emerald-light':
    'bg-emerald-200 hover:bg-emerald-300 dark:bg-emerald-800/80 dark:hover:bg-emerald-700/80 border border-emerald-300 dark:border-emerald-800 text-emerald-900 dark:text-white',
  teal: 'bg-teal-600 hover:bg-teal-700 dark:bg-teal-600 dark:hover:bg-teal-500 border border-teal-700 dark:border-teal-600 text-white dark:text-white',
  'teal-light':
    'bg-teal-200 hover:bg-teal-300 dark:bg-teal-800/80 dark:hover:bg-teal-700/80 border border-teal-300 dark:border-teal-800 text-teal-900 dark:text-white',
  cyan: 'bg-cyan-600 hover:bg-cyan-700 dark:bg-cyan-600 dark:hover:bg-cyan-500 border border-cyan-700 dark:border-cyan-600 text-white dark:text-white',
  'cyan-light':
    'bg-cyan-200 hover:bg-cyan-300 dark:bg-cyan-800/80 dark:hover:bg-cyan-700/80 border border-cyan-300 dark:border-cyan-800 text-cyan-900 dark:text-white',
  sky: 'bg-sky-600 hover:bg-sky-700 dark:bg-sky-600 dark:hover:bg-sky-500 border border-sky-700 dark:border-sky-600 text-white dark:text-white',
  'sky-light':
    'bg-sky-200 hover:bg-sky-300 dark:bg-sky-800/80 dark:hover:bg-sky-700/80 border border-sky-300 dark:border-sky-800 text-sky-900 dark:text-white',
  blue: 'bg-blue-600 hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-500 border border-blue-700 dark:border-blue-600 text-white dark:text-white',
  'blue-light':
    'bg-blue-200 hover:bg-blue-300 dark:bg-blue-800/80 dark:hover:bg-blue-700/80 border border-blue-300 dark:border-blue-800 text-blue-900 dark:text-white',
  indigo:
    'bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-600 dark:hover:bg-indigo-500 border border-indigo-700 dark:border-indigo-600 text-white dark:text-white',
  'indigo-light':
    'bg-indigo-200 hover:bg-indigo-300 dark:bg-indigo-800/80 dark:hover:bg-indigo-700/80 border border-indigo-300 dark:border-indigo-800 text-indigo-900 dark:text-white',
  violet:
    'bg-violet-600 hover:bg-violet-700 dark:bg-violet-600 dark:hover:bg-violet-500 border border-violet-700 dark:border-violet-600 text-white dark:text-white',
  'violet-light':
    'bg-violet-200 hover:bg-violet-300 dark:bg-violet-800/80 dark:hover:bg-violet-700/80 border border-violet-300 dark:border-violet-800 text-violet-900 dark:text-white',
  purple:
    'bg-purple-600 hover:bg-purple-700 dark:bg-purple-600 dark:hover:bg-purple-500 border border-purple-700 dark:border-purple-600 text-white dark:text-white',
  'purple-light':
    'bg-purple-200 hover:bg-purple-300 dark:bg-purple-800/80 dark:hover:bg-purple-700/80 border border-purple-300 dark:border-purple-800 text-purple-900 dark:text-white',
  fuchsia:
    'bg-fuchsia-600 hover:bg-fuchsia-700 dark:bg-fuchsia-600 dark:hover:bg-fuchsia-500 border border-fuchsia-700 dark:border-fuchsia-600 text-white dark:text-white',
  'fuchsia-light':
    'bg-fuchsia-200 hover:bg-fuchsia-300 dark:bg-fuchsia-800/80 dark:hover:bg-fuchsia-700/80 border border-fuchsia-300 dark:border-fuchsia-800 text-fuchsia-900 dark:text-white',
  pink: 'bg-pink-600 hover:bg-pink-700 dark:bg-pink-600 dark:hover:bg-pink-500 border border-pink-700 dark:border-pink-600 text-white dark:text-white',
  'pink-light':
    'bg-pink-200 hover:bg-pink-300 dark:bg-pink-800/80 dark:hover:bg-pink-700/80 border border-pink-300 dark:border-pink-800 text-pink-900 dark:text-white',
  rose: 'bg-rose-600 hover:bg-rose-700 dark:bg-rose-600 dark:hover:bg-rose-500 border border-rose-700 dark:border-rose-600 text-white dark:text-white',
  'rose-light':
    'bg-rose-200 hover:bg-rose-300 dark:bg-rose-800/80 dark:hover:bg-rose-700/80 border border-rose-300 dark:border-rose-800 text-rose-900 dark:text-white',
  slate:
    'bg-slate-600 hover:bg-slate-700 dark:bg-slate-600 dark:hover:bg-slate-500 border border-slate-700 dark:border-slate-600 text-white dark:text-white',
  'slate-light':
    'bg-slate-200 hover:bg-slate-300 dark:bg-slate-800/80 dark:hover:bg-slate-700/80 border border-slate-300 dark:border-slate-800 text-slate-900 dark:text-white',
  gray: 'bg-gray-600 hover:bg-gray-700 dark:bg-gray-600 dark:hover:bg-gray-500 border border-gray-700 dark:border-gray-600 text-white dark:text-white',
  'gray-light':
    'bg-gray-200 hover:bg-gray-300 dark:bg-gray-800/80 dark:hover:bg-gray-700/80 border border-gray-300 dark:border-gray-800 text-gray-900 dark:text-white',
  zinc: 'bg-zinc-600 hover:bg-zinc-700 dark:bg-zinc-600 dark:hover:bg-zinc-500 border border-zinc-700 dark:border-zinc-600 text-white dark:text-white',
  'zinc-light':
    'bg-zinc-200 hover:bg-zinc-300 dark:bg-zinc-800/80 dark:hover:bg-zinc-700/80 border border-zinc-300 dark:border-zinc-800 text-zinc-900 dark:text-white',
  neutral:
    'bg-neutral-600 hover:bg-neutral-700 dark:bg-neutral-600 dark:hover:bg-neutral-500 border border-neutral-700 dark:border-neutral-600 text-white dark:text-white',
  'neutral-light':
    'bg-neutral-200 hover:bg-neutral-300 dark:bg-neutral-800/80 dark:hover:bg-neutral-700/80 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-white',
  stone:
    'bg-stone-600 hover:bg-stone-700 dark:bg-stone-600 dark:hover:bg-stone-500 border border-stone-700 dark:border-stone-600 text-white dark:text-white',
  'stone-light':
    'bg-stone-200 hover:bg-stone-300 dark:bg-stone-800/80 dark:hover:bg-stone-700/80 border border-stone-300 dark:border-stone-800 text-stone-900 dark:text-white',
  black:
    'bg-black hover:bg-gray-900 border border-black dark:border-black text-white dark:text-white',
  white:
    'bg-white hover:bg-gray-100 border border-primary-200 dark:border-primary-800 text-primary-900 dark:text-white',
}

export const LIGHT_COLOR_HEX_CODES: Record<Color, string> = {
  red: '#dc2626',
  'red-light': '#fecaca',
  orange: '#ea580c',
  'orange-light': '#fed7aa',
  amber: '#d97706',
  'amber-light': '#fde68a',
  yellow: '#facc15',
  'yellow-light': '#fef08a',
  lime: '#65a30d',
  'lime-light': '#d9f99d',
  green: '#16a34a',
  'green-light': '#86efac',
  emerald: '#059669',
  'emerald-light': '#a7f3d0',
  teal: '#0d9488',
  'teal-light': '#99f6e4',
  cyan: '#0891b2',
  'cyan-light': '#a5f3fc',
  sky: '#0284c7',
  'sky-light': '#bae6fd',
  blue: '#2563eb',
  'blue-light': '#bfdbfe',
  indigo: '#4f46e5',
  'indigo-light': '#c7d2fe',
  violet: '#7c3aed',
  'violet-light': '#ddd6fe',
  purple: '#9333ea',
  'purple-light': '#e9d5ff',
  fuchsia: '#c026d3',
  'fuchsia-light': '#f5d0fe',
  pink: '#db2777',
  'pink-light': '#fbcfe8',
  rose: '#e11d48',
  'rose-light': '#fecdd3',
  slate: '#475569',
  'slate-light': '#e2e8f0',
  gray: '#4b5563',
  'gray-light': '#e5e7eb',
  zinc: '#52525b',
  'zinc-light': '#e4e4e7',
  neutral: '#525252',
  'neutral-light': '#e5e5e5',
  stone: '#57534e',
  'stone-light': '#e7e5e4',
  black: '#000000',
  white: '#ffffff',
}

export const LIGHT_HEX_CODE_TO_COLOR: Record<string, Color> = Object.entries(
  LIGHT_COLOR_HEX_CODES,
).reduce(
  (acc, [color, hexCode]) => {
    acc[hexCode] = color as Color
    return acc
  },
  {} as Record<string, Color>,
)

export const DARK_COLOR_HEX_CODES: Record<Color, string> = {
  red: '#b91c1c',
  'red-light': '#991b1b',
  orange: '#ea580c',
  'orange-light': '#9a3412',
  amber: '#d97706',
  'amber-light': '#92400e',
  yellow: '#eab308',
  'yellow-light': '#9a3412',
  lime: '#65a30d',
  'lime-light': '#3f6212',
  green: '#16a34a',
  'green-light': '#15803d',
  emerald: '#059669',
  'emerald-light': '#065f46',
  teal: '#0d9488',
  'teal-light': '#115e59',
  cyan: '#0891b2',
  'cyan-light': '#155e75',
  sky: '#0284c7',
  'sky-light': '#075985',
  blue: '#2563eb',
  'blue-light': '#1e40af',
  indigo: '#4f46e5',
  'indigo-light': '#3730a3',
  violet: '#7c3aed',
  'violet-light': '#5b21b6',
  purple: '#9333ea',
  'purple-light': '#6b21a8',
  fuchsia: '#c026d3',
  'fuchsia-light': '#86198f',
  pink: '#db2777',
  'pink-light': '#9d174d',
  rose: '#e11d48',
  'rose-light': '#9f1239',
  slate: '#475569',
  'slate-light': '#1e293b',
  gray: '#4b5563',
  'gray-light': '#1f2937',
  zinc: '#52525b',
  'zinc-light': '#27272a',
  neutral: '#525252',
  'neutral-light': '#262626',
  stone: '#57534e',
  'stone-light': '#292524',
  black: '#000000',
  white: '#ffffff',
}

export const DARK_HEX_CODE_TO_COLOR: Record<string, Color> = Object.entries(
  DARK_COLOR_HEX_CODES,
).reduce(
  (acc, [color, hexCode]) => {
    acc[hexCode] = color as Color
    return acc
  },
  {} as Record<string, Color>,
)

export const COLOR_CLASSNAMES_FOR_TEXT: Record<Color, string> = {
  red: 'text-red-600 dark:text-red-700',
  'red-light': 'text-red-200 dark:text-red-800/80',
  orange: 'text-orange-600 dark:text-orange-600',
  'orange-light': 'text-orange-200 dark:text-orange-800/80',
  amber: 'text-amber-600 dark:text-amber-600',
  'amber-light': 'text-amber-200 dark:text-amber-800/80',
  yellow: 'text-yellow-400 dark:text-orange-600',
  'yellow-light': 'text-yellow-200/80 dark:text-orange-900',
  lime: 'text-lime-600 dark:text-lime-600',
  'lime-light': 'text-lime-200 dark:text-lime-800/80',
  green: 'text-green-600 dark:text-green-600',
  'green-light': 'text-green-300 dark:text-green-700/80',
  emerald: 'text-emerald-600 dark:text-emerald-600',
  'emerald-light': 'text-emerald-200 dark:text-emerald-800/80',
  teal: 'text-teal-600 dark:text-teal-600',
  'teal-light': 'text-teal-200 dark:text-teal-800/80',
  cyan: 'text-cyan-600 dark:text-cyan-600',
  'cyan-light': 'text-cyan-200 dark:text-cyan-800/80',
  sky: 'text-sky-600 dark:text-sky-600',
  'sky-light': 'text-sky-200 dark:text-sky-800/80',
  blue: 'text-blue-600 dark:text-blue-600',
  'blue-light': 'text-blue-200 dark:text-blue-800/80',
  indigo: 'text-indigo-600 dark:text-indigo-600',
  'indigo-light': 'text-indigo-200 dark:text-indigo-800/80',
  violet: 'text-violet-600 dark:text-violet-600',
  'violet-light': 'text-violet-200 dark:text-violet-800/80',
  purple: 'text-purple-600 dark:text-purple-600',
  'purple-light': 'text-purple-200 dark:text-purple-800/80',
  fuchsia: 'text-fuchsia-600 dark:text-fuchsia-600',
  'fuchsia-light': 'text-fuchsia-200 dark:text-fuchsia-800/80',
  pink: 'text-pink-600 dark:text-pink-600',
  'pink-light': 'text-pink-200 dark:text-pink-800/80',
  rose: 'text-rose-600 dark:text-rose-600',
  'rose-light': 'text-rose-200 dark:text-rose-800/80',
  slate: 'text-slate-600 dark:text-slate-600',
  'slate-light': 'text-slate-200 dark:text-slate-800/80',
  gray: 'text-gray-600 dark:text-gray-600',
  'gray-light': 'text-gray-200 dark:text-gray-800/80',
  zinc: 'text-zinc-600 dark:text-zinc-600',
  'zinc-light': 'text-zinc-200 dark:text-zinc-800/80',
  neutral: 'text-neutral-600 dark:text-neutral-600',
  'neutral-light': 'text-neutral-200 dark:text-neutral-800/80',
  stone: 'text-stone-600 dark:text-stone-600',
  'stone-light': 'text-stone-200 dark:text-stone-800/80',
  black: 'text-black dark:text-black',
  white: 'text-white',
}

interface ColorDefinition {
  color: Color
  classNames: string
}

interface ColorPair {
  left: ColorDefinition
  right: ColorDefinition | null
}

export const COLOR_PAIRS: ColorPair[] = Object.entries(COLOR_CLASSNAMES).reduce(
  (acc, [color, classNames], index, array) => {
    if (index % 2 === 0) {
      acc.push({
        left: { color: color as Color, classNames },
        right: array[index + 1]
          ? {
              color: array[index + 1][0] as Color,
              classNames: array[index + 1][1],
            }
          : null,
      })
    }
    return acc
  },
  [] as ColorPair[],
)

export const COLOR_LABELS: Record<Color, string> = {
  slate: 'Slate',
  'slate-light': 'Light Slate',
  gray: 'Gray',
  'gray-light': 'Light Gray',
  zinc: 'Zinc',
  'zinc-light': 'Light Zinc',
  neutral: 'Neutral',
  'neutral-light': 'Light Neutral',
  stone: 'Stone',
  'stone-light': 'Light Stone',
  red: 'Red',
  'red-light': 'Light Red',
  orange: 'Orange',
  'orange-light': 'Light Orange',
  amber: 'Amber',
  'amber-light': 'Light Amber',
  yellow: 'Yellow',
  'yellow-light': 'Light Yellow',
  lime: 'Lime',
  'lime-light': 'Light Lime',
  green: 'Green',
  'green-light': 'Light Green',
  emerald: 'Emerald',
  'emerald-light': 'Light Emerald',
  teal: 'Teal',
  'teal-light': 'Light Teal',
  cyan: 'Cyan',
  'cyan-light': 'Light Cyan',
  sky: 'Sky',
  'sky-light': 'Light Sky',
  blue: 'Blue',
  'blue-light': 'Light Blue',
  indigo: 'Indigo',
  'indigo-light': 'Light Indigo',
  violet: 'Violet',
  'violet-light': 'Light Violet',
  purple: 'Purple',
  'purple-light': 'Light Purple',
  fuchsia: 'Fuchsia',
  'fuchsia-light': 'Light Fuchsia',
  pink: 'Pink',
  'pink-light': 'Light Pink',
  rose: 'Rose',
  'rose-light': 'Light Rose',
  black: 'Black',
  white: 'White',
}

export const STATUS_COLOR_CLASSNAMES: Record<StatusType, string> = {
  pending:
    'bg-yellow-200/80 dark:bg-yellow-800/60 text-yellow-900 dark:text-yellow-100 border border-yellow-300 dark:border-yellow-800',
  running:
    'bg-blue-200/80 dark:bg-blue-800/60 text-blue-900 dark:text-blue-100 border border-blue-300 dark:border-blue-800',
  succeeded:
    'bg-green-200/80 dark:bg-green-800/60 text-green-900 dark:text-green-100 border border-green-300 dark:border-green-800',
  failed:
    'bg-red-200/80 dark:bg-red-800/60 text-red-900 dark:text-red-100 border border-red-300 dark:border-red-800',
  not_found:
    'bg-zinc-200/80 dark:bg-zinc-800/60 text-zinc-900 dark:text-zinc-100 border border-zinc-300 dark:border-zinc-800',
}

export const STATUS_SPINNER_COLOR_CLASSNAMES: Record<StatusType, string> = {
  pending:
    'fill-yellow-700 dark:fill-yellow-300 text-yellow-400 dark:text-yellow-600',
  running: 'fill-blue-700 dark:fill-blue-300 text-blue-400 dark:text-blue-600',
  succeeded:
    'fill-green-700 dark:fill-green-300 text-green-400 dark:text-green-600',
  failed: 'fill-red-700 dark:fill-red-300 text-red-400 dark:text-red-600',
  not_found:
    'fill-zinc-700 dark:fill-zinc-300 text-zinc-400 dark:text-zinc-600',
}

export const COLORS: Color[] = Object.keys(COLOR_CLASSNAMES) as Color[]

// Standard color order: red -> orange -> yellow -> green -> blue -> purple -> pink/rose -> grays -> black/white
// All light colors first, then all dark colors
export const SORTED_COLORS: Color[] = [
  // Light colors (in standard order)
  'red-light',
  'orange-light',
  'amber-light',
  'yellow-light',
  'lime-light',
  'green-light',
  'emerald-light',
  'teal-light',
  'cyan-light',
  'sky-light',
  'blue-light',
  'indigo-light',
  'violet-light',
  'purple-light',
  'fuchsia-light',
  'pink-light',
  'rose-light',
  'slate-light',
  'gray-light',
  'zinc-light',
  'neutral-light',
  'stone-light',
  // Dark colors (in standard order)
  'red',
  'orange',
  'amber',
  'yellow',
  'lime',
  'green',
  'emerald',
  'teal',
  'cyan',
  'sky',
  'blue',
  'indigo',
  'violet',
  'purple',
  'fuchsia',
  'pink',
  'rose',
  'slate',
  'gray',
  'zinc',
  'neutral',
  'stone',
  'black',
  // White is last
  'white',
]

export const LIGHT_COLORS: Color[] = Object.keys(
  LIGHT_COLOR_HEX_CODES,
) as Color[]

export const DARK_COLORS: Color[] = Object.keys(DARK_COLOR_HEX_CODES) as Color[]

export const SATURATED_COLORS: Color[] = [
  'red',
  'orange',
  'amber',
  'yellow',
  'lime',
  'green',
  'emerald',
  'teal',
  'cyan',
  'sky',
  'blue',
  'indigo',
  'violet',
  'purple',
  'fuchsia',
  'pink',
  'rose',
]

export const UNSATURATED_COLORS: Color[] = [
  'slate',
  'gray',
  'zinc',
  'neutral',
  'stone',
]
